<template>
  <div class="main-container">
    <div class="title">{{ reportName }}</div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <div class="statistics">
        <span>汇总数据</span>
        <template v-if="reportType === 'extra'">
          <span>总人数：<b>{{ statistics.userNum }}</b></span>
          <span>收入积分：<b>{{ statistics.incomes }}</b></span>
          <span>支出积分：<b>{{ statistics.expenses }}</b></span>
          <span>积分合计（港币）：<b>{{ statistics.commissionSum }}</b></span>
        </template>
        <template v-else>
          <span>总人数：<b>{{ statistics.userNum }}</b></span>
          <span>保单件数：<b>{{ statistics.policyNum }}</b></span>
          <span>保费合计(美元)：<b>{{ statistics.feeSum }}</b></span>
          <span>佣金合计(港币)：<b>{{ statistics.commissionSum }}</b></span>
        </template>
        <span class="settlement-status"
          >结算状态：
          <Tag v-if="settlementStatus == 0" color="orange">待结算</Tag>
          <Tag v-else-if="settlementStatus == 1" color="green">已结算</Tag></span
        >
      </div>

      <div class="search-box min ivu-form">
        <div class="input-item">
          <span class="label">{{ reportType === 'extra' ? 'IFA' : '代理人' }}</span>
          <Select v-model="searchParams.owerId" clearable filterable>
            <Option v-for="item in userList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">查询</Button>
        </div>
      </div>
      <Table ref="selection" :columns="reportType === 'extra' ? extraColumns : columns" :data="tableData">
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="detail(row)">明细</span>
        </template>
      </Table>
    </div>
    <div class="bottom-btn">
      <Button type="primary" :loading="loading" v-if="settlementStatus == 0 && reportType !== 'extra'" @click="calculate">计算基本法</Button>
      <Button type="primary" ghost @click="back($route.query.backUrl)">返回</Button>
      <Button type="primary" v-if="settlementStatus == 0" ghost @click="toBack">上一步</Button>
      <Button type="primary" ghost @click="handleExport">导出报表</Button>
      <Button type="primary" v-if="settlementStatus == 0" @click="settlement">完成结算</Button>
    </div>
    <selPolicyModal ref="selPolicyModalRef" @close="getList"></selPolicyModal>
    <extraDetailModal ref="extraDetailModalRef"></extraDetailModal>
  </div>
</template>
      
      <script>
import { common, pageTool } from '@/api/mixins';
import { config } from './step2.config.js';

import selPolicyModal from './components/selPolicyModal.vue';
import extraDetailModal from './components/extraDetailModal.vue';

export default {
  mixins: [common, config, pageTool],
  props: {
    id: {
      type: String,
      default: ''
    },
    settlementStatus: {
      type: String,
      default: ''
    },
    reportName: {
      type: String,
      default: ''
    },
    reportType: {
      type: String,
      default: 'basic'
    }
  },

  components: {
    selPolicyModal,
    extraDetailModal
  },

  computed: {
    apiPrefix() {
      return this.reportType === 'extra' ? '/buz/ifaExtraSettlementReport' : '/buz/ifaSettlementReport';
    }
  },

  data() {
    const dic = JSON.parse(localStorage.dic);
    return {
      userList: [],
      visible: false,
      loading: false,
      statistics: {}
    };
  },
  created() {
    this.getColumns();
    this.initListAjax(this.apiPrefix + '/querySummaryData');
    this.getStatistics();
    this.getUserList();
  },
  methods: {
    getUserList() {
      this.$http({
        url: '/buz/userBase/list',
        type: 'POST',
        data: {
          selectSub: 1
        }
      }).then(res => {
        this.userList = res.data.filter(i => i.ifaType != 2);
      });
    },
    detail(row) {
      if (this.reportType === 'extra') {
        this.$refs.extraDetailModalRef.open({
          apiPrefix: this.apiPrefix,
          id: this.id,
          owerId: row.owerId
        });
        return;
      }
      this.$router.push({
        path: '/basicLaw/settlementDetail',
        query: {
          backUrl: this.$route.fullPath,
          id: this.id,
          owerId: row.owerId,
          settlementStatus: row.settlementStatus,
          reportType: this.reportType
        }
      });
    },
    handleExport() {
      let params = {
        id: this.id
      };
      this.$units.downloadFile(this.apiPrefix + '/export', params, 'GET');
    },
    toBack() {
      this.$notice.inquiry('是否返回上一步？').then(() => {
        if (this.reportType === 'extra') {
          this.$emit('back');
          return;
        }
        this.$http({
          url: this.apiPrefix + '/toBack',
          type: 'GET',
          data: {
            id: this.id
          }
        }).then(res => {
          this.$emit('back');
        });
      });
    },

    calculate() {
      this.$notice.inquiry('请确认是否计算基本法？').then(() => {
        this.listLoading = true;
        this.loading = true;
        this.$http({
          url: this.apiPrefix + '/calculate',
          type: 'GET',
          data: {
            id: this.id
          }
        }).then(res => {
          this.$notice.success('操作成功');
          this.getList();
          this.getStatistics();
        }).finally(() => {
          this.loading = false;
        });
      });
    },
    settlement() {
      this.$notice.inquiry('请确认是否完成结算？').then(() => {
        this.$http({
          url: this.apiPrefix + '/settlement',
          type: 'GET',
          data: {
            id: this.id
          }
        }).then(res => {
          this.$notice.success('操作成功');
          this.$emit('success');
        });
      });
    },
    getStatistics() {
      this.$http({
        url: this.apiPrefix + '/statistics',
        type: 'GET',
        data: {
          id: this.id
        }
      })
        .then(res => {
          this.statistics = res.data;
        })
        .finally(() => {
          this.$notice.hideLoading();
        });
    },
    setListParams(params) {
      params.id = this.id;
    },
    setRequstType() {
      return 'GET';
    }
  }
};
</script>
  <style lang="scss" scoped>
.main-container {
  /deep/.tip-icon {
    width: 15px;
    height: 15px;
    border-radius: 15px;
    background: transparent;
    border: 1px solid #ccc;
    color: #ccc;
    display: inline-block;
    text-align: center;
    line-height: 15px;
    font-size: 12px;
    cursor: pointer;
    top: 50%;
  }
  .settlement-status {
    position: fixed;
    right: 10px;
    top: 10px;
  }
  .title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .statistics {
    margin-bottom: 10px;
    span {
      margin-right: 20px;
    }
    b {
      color: #f59045;
    }
  }

  .bottom-btn {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 70px;
    background-color: #fff;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #ccc;

    .ivu-btn {
      width: 140px;
      height: 35px;
    }

    .ivu-btn + .ivu-btn {
      margin-left: 20px;
    }
  }
}
</style>
      